import axios from "../utils/request";

// 获取用户信息
export function getUserInfo(data) {
  return axios({
    url: "/wxpubapp/edu/getpersoninfo",
    method: "get",
    params: {
      personId: data,
    },
  });
}

// 获取用户协议
export function getAgree(data) {
  return axios({
    url: "/cms/cms-article/getArticle",
    method: "get",
    params: {
      title: data,
    },
  });
}
// 用户下载地址
export function downloadApp(data) {
  return axios({
    url: "/base/base-version/downloadApp",
    method: "get",
    params: {
      name: data,
    },
  });
}
